import React from 'react';
import { Globe } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function Hero() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[90vh] flex items-center overflow-hidden pt-20 pb-16 px-4" data-id="element-60">
      {/* Background Effects */}
      <div className="absolute inset-0 z-0 flex items-center justify-center" data-id="element-61">
        <div className="w-[800px] h-[800px] bg-accent-500/10 rounded-full blur-[120px] opacity-50 mix-blend-screen" data-id="element-62" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto w-full text-center" data-id="element-63">
        <FadeIn delay={0.1} data-id="element-64">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-navy-800 border border-accent-500/20 text-accent-400 text-sm font-medium mb-8 shadow-[0_0_15px_rgba(34,211,238,0.1)]" data-id="element-65">
            <Globe className="w-4 h-4" data-id="element-66" />
            <span data-id="element-67">Para profesionales en Latinoamérica</span>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-68">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold leading-[1.1] mb-6 text-white" data-id="element-69">
            Cómo Conseguir tu{' '}
            <span className="text-transparent bg-clip-text bg-accent-gradient text-glow" data-id="element-70">
              Primer Empleo Remoto
            </span>{' '}
            y{' '}
            <span className="text-transparent bg-clip-text bg-accent-gradient text-glow" data-id="element-71">
              Ganar en Dólares
            </span>{' '}
            desde Cualquier País de Latinoamérica
          </h1>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-72">
          <p className="text-lg md:text-xl text-slate-400 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-73">
            Consigue tu primer rol internacional en 30 días, sin experiencia
            previa en el extranjero y con el inglés que ya tienes hoy.
          </p>
        </FadeIn>

        {/* Product Image */}
        <FadeIn delay={0.35} data-id="element-74">
          <div className="relative flex justify-center mb-10" data-id="element-75">
            <div className="absolute inset-0 bg-accent-500/5 rounded-full blur-[80px] scale-75 pointer-events-none" data-id="element-76" />
            <img src="https://cdn.magicpatterns.com/uploads/6nfmxCFWvhiCAiENP4B2ej/Mockup_Trabajo_Remoto_3.png" alt="Persona leyendo el Kit de Supervivencia para Primer Empleo Remoto en una tablet" className="relative w-full max-w-md rounded-2xl shadow-2xl shadow-black/40" data-id="element-77" />
          </div>
        </FadeIn>

        {/* CTA Button */}
        <FadeIn delay={0.4} data-id="element-78">
          <div className="flex flex-col items-center gap-4" data-id="element-79">
            <Button onClick={scrollToOffer} className="text-lg px-10 py-5" data-id="element-80">
              ¡QUIERO MI PRIMER EMPLEO EN DÓLARES!
            </Button>
          </div>
          <p className="mt-4 text-sm text-slate-500 flex items-center justify-center gap-2" data-id="element-81">
            <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" data-id="element-82" />
            Acceso inmediato. Pago único y seguro.
          </p>
        </FadeIn>
      </div>
    </section>;
}